export default {
  results: state => state.results,
  loading: state => state.loading,
  error: state => state.error,

  products: state => state.products,
  filters: state => state.filters,

  searchRefinements: state => state.searchRefinements,

  pagination: state => state.pagination,

  hasResults: state => state.products.length > 0,

  matchingProductCount: state => state.matchingProductCount,
  productDetails: state => state.productDetails,
  globalSearch: state => state.globalSearch,
  showDummyData: state => state.showDummyData
}